import React from 'react';
import Popup from '../common/popup/Popup';
import { Card, Badge, Button } from 'react-bootstrap';
import '../../styles/components/user/PlanSelectionPopup.css';

const PlanSelectionPopup = ({ show, onClose, onPlanSelect }) => {
  if (!show) return null;
  return (
    <Popup title="Select a Plan" onCancel={onClose} className="plan-popup">
      <div className="plan-selection">
        <Card className="plan-card">
          <Card.Body>
            <Card.Title>Support Us Monthly</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">£4.99/month (recurring)</Card.Subtitle>
            <div className="card-text">
              <ul>
                <li>Support site improvements and maintenance</li>
                <li>Recurring monthly billing</li>
              </ul>
            </div>
            <Button variant="primary" className="w-100 subscribe-button" onClick={() => { onClose(); onPlanSelect('monthly_support'); }}>
              Subscribe
            </Button>
          </Card.Body>
        </Card>
        <Card className="plan-card highlight-plan">
          <Card.Body>
            <Badge bg="success" className="suggested-badge">Popular</Badge>
            <Card.Title>Support Us 3-Monthly</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">£12.99/3 months (recurring)</Card.Subtitle>
            <div className="card-text">
              <ul>
                <li>Support site improvements and maintenance</li>
                <li>Recurring every 3 months</li>
              </ul>
            </div>
            <Button variant="primary" className="w-100 subscribe-button" onClick={() => { onClose(); onPlanSelect('3monthly_support'); }}>
              Subscribe
            </Button>
          </Card.Body>
        </Card>
        <Card className="plan-card">
          <Card.Body>
            <Card.Title>Premium Monthly</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">£14.99/month (recurring)</Card.Subtitle>
            <div className="card-text">
              <ul>
                <li>Build your own itineraries</li>
                <li>Use our AI tool to find destinations</li>
                <li>7-Day Free Trial available</li>
                <li>Recurring monthly billing</li>
              </ul>
            </div>
            <Button variant="primary" className="w-100 subscribe-button" onClick={() => { onClose(); onPlanSelect('monthly_premium'); }}>
              Subscribe
            </Button>
          </Card.Body>
        </Card>
        <Card className="plan-card highlight-plan">
          <Card.Body>
            <Badge bg="success" className="suggested-badge">Suggested</Badge>
            <Card.Title>Premium 3-Monthly</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">£39.99/3 months (recurring)</Card.Subtitle>
            <div className="card-text">
              <ul>
                <li>Build your own itineraries</li>
                <li>Use our AI tool to find destinations</li>
                <li>7-Day Free Trial available</li>
                <li>Recurring every 3 months</li>
              </ul>
            </div>
            <Button variant="primary" className="w-100 subscribe-button" onClick={() => { onClose(); onPlanSelect('3monthly_premium'); }}>
              Subscribe
            </Button>
          </Card.Body>
        </Card>
      </div>
    </Popup>
  );
};

export default PlanSelectionPopup;
